export default __webpack_public_path__ + "static/media/creator-cover.fe1e527d.png";